import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  Input,
} from 'reactstrap';

// Generic confirmation dialog for CRUD actions (approve / reject / cancel /
// etc.). Title, message, and the confirm button's label + color are driven by
// the caller so one component covers every confirm flow.
//
// When `showNotes` is set, a notes textarea is rendered and its value is passed
// to `onConfirm(notes)` — used by the approval workflow to fill ApprovalLog.Notes.
const ConfirmModal = ({
  show,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  confirmColor = 'primary',
  onConfirm,
  onClose,
  showNotes = false,
  notesLabel = 'Notes',
  notesPlaceholder = 'Optional — recorded in the approval log',
}) => {
  const [notes, setNotes] = useState('');

  // Reset the notes field each time the dialog is opened.
  useEffect(() => {
    if (show) setNotes('');
  }, [show]);

  return (
    <Modal isOpen={show} toggle={onClose} centered data-bs-backdrop='static'>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>
        <div>{message}</div>
        {showNotes && (
          <div className='mt-3'>
            <Label for='confirm-notes' className='form-label'>
              {notesLabel}
            </Label>
            <Input
              type='textarea'
              id='confirm-notes'
              rows={3}
              maxLength={500}
              placeholder={notesPlaceholder}
              value={notes}
              onChange={e => setNotes(e.target.value)}
            />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color='light'
          className='btn-sm'
          onClick={onClose}
          data-testid='confirm-cancel'
        >
          Close
        </Button>
        <Button
          color={confirmColor}
          className='btn-sm'
          onClick={() => onConfirm(notes)}
          data-testid='confirm-ok'
        >
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
